import { useCifraClient } from "../cifra-client";

const { cifraClient } = useCifraClient();

const URL_BASE = '/api_publica/v1/calificaciones/definiciones';

export default {
  get(modeloDefinicion, idDefinicion, idCuaderno, options) {
    const defaults = {
      params: {
        model_name: modeloDefinicion,
        id: idDefinicion,
        cuaderno_id: idCuaderno,
      }
    };
    const opts = { ...defaults, ...options };
    return cifraClient.get(`${URL_BASE}/${idDefinicion}`, opts);
  },
};
